import { SbbError } from "@sbb-esta/lyne-react/form-field";

interface LyneFieldErrorProps {
  error: string | undefined | null;
}

export const LyneFieldError: React.FC<LyneFieldErrorProps> = ({ error }) => {
  if (!error) {
    return null;
  }

  return <SbbError>{error}</SbbError>;
};
